import { useMemo } from "react";
import { DateTime } from "luxon";
import { Column } from "react-table";

import { GetBlockchainAnimalDataByKillNumber_blockchainAnimalDataByKillNumber_weights } from "api/Blockchain/types/GetBlockchainAnimalDataByKillNumber";
import { GetBlockchainAnimalDataByPassport_blockchainAnimalDataByPassport_weights } from "api/Blockchain/types/GetBlockchainAnimalDataByPassport";
import { Spacer, Table, Text, Title } from "components";
import { TABLE_IDS } from "constants/Interface";
import { AnimalDataTypes } from "../";

type AnimalWeightType =
  | GetBlockchainAnimalDataByPassport_blockchainAnimalDataByPassport_weights
  | GetBlockchainAnimalDataByKillNumber_blockchainAnimalDataByKillNumber_weights;

interface BlockchainAnimalWeightTableProps {
  weights: AnimalDataTypes["weights"];
}

const COLUMN_IDS = {
  HOLDING_ID: "holdingId",
  VALUE: "value",
  UNIT: "unit",
  DATE: "date",
  CREATED_BY: "createdBy",
};

export const BlockchainAnimalWeightTable: React.FC<BlockchainAnimalWeightTableProps> = ({ weights }) => {
  const data = useMemo(() => weights, []);

  //@ts-expect-error
  const columns: Column<AnimalWeightType>[] = useMemo(
    () => [
      {
        id: COLUMN_IDS.HOLDING_ID,
        Header: "Holding Id",
        accessor: "holdingId",
      },
      {
        id: COLUMN_IDS.VALUE,
        Header: "Value",
        accessor: "value",
      },
      {
        id: COLUMN_IDS.UNIT,
        Header: "Unit",
        accessor: "unit",
      },
      {
        id: COLUMN_IDS.DATE,
        Header: "Date",
        accessor: "date",
        Cell: ({ row }) =>
          row.values[COLUMN_IDS.DATE] ? DateTime.fromISO(row.values[COLUMN_IDS.DATE]).toLocaleString() : "\u2014",
      },
      {
        id: COLUMN_IDS.CREATED_BY,
        Header: "Created By",
        accessor: "createdBy",
      },
    ],
    [],
  );

  return (
    <>
      <Title secondary>Weights</Title>

      <Spacer baselineHeight={1} />

      {data?.length ? (
        <Table<AnimalWeightType> columns={columns} data={data} tableId={TABLE_IDS.BLOCKCHAIN_ANIMAL_WEIGHTS} />
      ) : (
        <Text smallest>
          <em>No Weight Data for this Animal</em>
        </Text>
      )}
    </>
  );
};
